import { ITheme } from "../../Theme/Theme.types.js";
import { ButtonProps } from "../Button.types.js";

export const getBorderRadius = ({ size, theme }: { size: NonNullable<ButtonProps["size"]>; theme: ITheme }): string => {
    if (size === "small") return theme.radius.xs;
    return theme.radius.s;
};
